import { crv, cva } from '@/styled-system/css';

export const carouselSlideStyles = cva({
  base: {
    flexGrow: 0,
    flexShrink: 0,
  },
  variants: {
    ...crv('slideAlign', {
      start: {
        scrollSnapAlign: 'start',
      },
      center: {
        scrollSnapAlign: 'center',
      },
      end: {
        scrollSnapAlign: 'end',
      },
    }),
  },
});
